<template>
    <div v-show="podStore.showInactivityWarning"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div class="bg-white w-full max-w-[90vw] lg:max-w-md p-6 flex flex-col gap-6 rounded-lg shadow-xl">
            <div class="flex items-start justify-between gap-4">
                <h3 class="text-2xl font-bold">Bent u er nog?</h3>
            </div>

            <div class="text-center">
                <p class="mb-4 text-lg">
                    De pagina wordt opnieuw geladen vanwege inactiviteit.
                </p>
                <div class="mb-4 text-6xl font-bold text-primary">
                    {{ podStore.inactivityCountdown }}
                </div>
                <p class="text-gray-600">seconden</p>
            </div>

            <div class="flex justify-center">
                <button @click="podStore.cancelInactivityReload()" class="button-orange-contained">
                    Doorgaan met configureren
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { usePodStore } from '@/stores/pod'

const podStore = usePodStore()
</script>
